module.exports = __webpack_public_path__ + "img/KTP_shili.2e3411db.png";